<template>
    <div :style="{'background-image': `url(${require('../../assets/img/note_img.png')}) `}" style="height: 700px; background-repeat: no-repeat;
     background-size: 800px 800px; width: 800px;">
        <div style="margin:0px 80px 0px 80px; padding-top: 50px;">
            <CRow class="mb-3 ml-2">
                <h3 style="font-weight: bold;">신용카드  <span v-if="kspayItem.payStatus != 'C'" > 매출전표 </span> <span v-if="kspayItem.payStatus === 'C'" > [취소전표]</span> </h3>
            </CRow>
            <div class="table">
                <table class="type09">
                    <colgroup>
                        <col width="120px;">
                        <col width="300px">
                        <col width="120px;">
                        <col width="300px">
                    </colgroup>
                    <thead>
                    <tr>
                        <th scope="cols" colspan="2">결제정보</th>
                        <th scope="cols"></th>
                        <th scope="cols"></th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th>카드종류</th>
                            <td>{{cardName}}</td>
                            <th>카드번호</th>
                            <td>{{kspayItem.cardNum}}</td>
                        </tr>
                        <tr>
                            <th>거래종류</th>
                            <td>{{payMethod }}</td>
                            <th>거래일시</th>
                            <td>
                                {{$moment(kspayItem.insertTime).format("YYYY-MM-DD HH:mm:ss" )}}
                                <br>  <span v-if="kspayItem.payStatus === 'C'" >(취소일 :{{$moment(cancelDate).format("YYYY-MM-DD" )}} {{cancelDateHHmmss}})</span>
                            </td>
                        </tr>
                        <tr>
                            <th>할부개월</th>
                            <td>
                                <span v-if="kspayItem.installmentCode != '00' && kspayItem.installmentCode != 'null' && kspayItem.installmentCode != null" >
                                    {{kspayItem.installmentCode}} 개월
                                </span>
                                <span v-if="kspayItem.installmentCode == '00'" >
                                    일시불
                                </span>
                                <span v-if="kspayItem.installmentCode == 'null' || kspayItem.installmentCode == null" >
                                    일시불
                                </span>
                            </td>
                            <th>승인번호</th>
                            <td>{{kspayItem.authNo}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="table">
                <table class="type09">
                    <colgroup>
                        <col width="120px;">
                        <col width="">
                        <col width="120px;">
                        <col width="">
                    </colgroup>
                    <thead>
                    <tr>
                        <th scope="cols" colspan="2">구매정보</th>
                        <th scope="cols"></th>
                        <th scope="cols"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <th>주문번호</th>
                        <td>{{payId}}</td>
                        <th>구매자명</th>
                        <td>{{kspayItem.buyerTel}}</td>
                    </tr>

                    <tr>
                        <th rowspan="2">상품명</th>
                        <td rowspan="2">요양서비스</td>
                        <th>환자명</th>
                        <td colspan="2">{{kspayItem.custName}}</td>
                    </tr>
                    <tr>
                        <th>합계금액</th>
                        <td><span v-if="kspayItem.payStatus === 'C'" >-{{kspayItem.amount | comma}} 원</span>
                            <span v-if="kspayItem.payStatus != 'C'" >{{kspayItem.amount | comma}} 원</span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="table">
                <table class="type09">
                    <colgroup>
                        <col width="330px;">
                        <col width="">
                    </colgroup>
                    <thead>
                    <tr>
                        <th scope="cols">이용상점정보</th>
                        <th scope="cols"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <th>판매자상호</th>
                        <td>{{companyItem.name}}</td>
                    </tr>
                    <tr>
                        <th>판매자 사업자등록번호</th>
                        <td>{{companyItem.registNo}}</td>
                    </tr>
                    <tr>
                        <th>판매자주소</th>
                        <td>{{companyItem.companyAddress}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-sm-0.5">
                <CButton label=""
                         type="button"
                         style="text-align: right; margin-left: 10px;"
                         class="btn btn-info " @click="printBtn">카드전표 인쇄
                </CButton>
            </div>
        </div>
    </div>
</template>
<style>
    .btn-col-margin{
        margin-top: 5px;
        margin-left: 15px;
        margin-right: 10px;
    }
    .col-title{
        width: 20%;
    }
    .table-span-margin{
        margin-left: 10%;
    }
    body {
        background: #eee;
    }


    table.type09 {
        border-collapse: collapse;
        text-align: left;
        line-height: 1.5;
        width:100%;
        color:black;
        background-color: white;

    }
    table.type09 thead th {
        padding: 10px;
        font-weight: bold;
        vertical-align: top;
        border-top:0px;
        color: #369;
        border-bottom: 3px solid #036;
    }
    table.type09 tbody th {
        padding: 10px;
        font-weight: bold;
        vertical-align: top;
        border-bottom: 1px solid #ccc;
        background: #f3f6f7;
    }
    table.type09 tbody {
        padding:20px
    }
    table.type09 td {
        padding: 10px;
        vertical-align: top;
        border-bottom: 1px solid #ccc;
    }
    table.type09 input[type="text"]
    {
        height: auto;
        line-height : normal;
        padding: .4em .5em;
        font-family: inherit;
        border: 1px solid #999;
        border-radius: 0;
        outline-style: none;
        -webkit-appearance: none;
        -moz-appearance: none; appearance: none; }
</style>
<script>
    import Vue from 'vue'
    import axios from "axios";
    import VueMoment from 'vue-moment'

    Vue.use(VueMoment);

    export default {
        name: 'Cardchit',
        components: {},
        data: function () {
            /* var vueData = {};
             vueData.mydate = new Date();*/

            return {
                custItem: {},
                custPayItem: {},
                kspayItem: {},
                payItems: {},
                companyItems: {},
                item: null,
                payId:'',
                cardName:'',
                approveDateHHmmss:""
            }
        },
        filters:{
            comma(val){
                return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
        },
        mounted() {
            const payId = this.$route.params.payId;
            axios.get('silver/pay/getPayDetailInfo/'+payId)
                .then(res => {
                    console.log(res.data.custPay);
                    this.kspayItem = res.data.custPay;
                    this.companyItem = res.data.company;
                    this.payId = this.$route.params.payId;
                    this.approveDateHHmmss = res.data.approveDateHHmmss;
                    this.cardName = res.data.cardName;
                    if (this.kspayItem.payMethod === 'C'){
                        this.payMethod = "카드";
                    }

                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        methods: {
            comma(val) {
                return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
            printBtn() {
                window.print();
            }
        }
    }
</script>
